import { type IframeAdapter, WIDGET_SDK_MESSAGE_SOURCE } from './IframeAdapter';

const isEmbedded = (): boolean => {
  try {
    return window !== window.parent;
  } catch {
    return false;
  }
};

export const realIframe: IframeAdapter = {
  isEmbedded,
  isWidgetSdkEmbed: () =>
    isEmbedded() && new URLSearchParams(window.location.search).has('vipps-widget'),
  postToParent: (message) =>
    // String messages are legacy protocols (e.g. mobilepay:rc=...) posted verbatim;
    // object messages are widget-sdk messages and get the source stamped.
    window.parent.postMessage(
      typeof message === 'string' ? message : { source: WIDGET_SDK_MESSAGE_SOURCE, ...message },
      '*'
    ),
  observeResize: (element, onResize) => {
    if (typeof ResizeObserver === 'undefined') {
      // fallback for environments without resize observer (older iOS/android webviews)
      const intervalId = setInterval(onResize, 500);
      return () => clearInterval(intervalId);
    }

    const observer = new ResizeObserver(onResize);
    observer.observe(element);

    return () => observer.disconnect();
  },
};
